import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { Table } from '@bitcine/cinesend-theme'
import AirlineValidatorParams from './components/airline_validator_params'
import useTableFilters from '../../hooks/use_table_filters'

// list of airlines and their validators configs
const AirlineSpecificValidatorsTable = () => {
  const { data: airlines, isLoading: isAirlinesLoading, error: airlinesError } = useQuery(['airlines'])

  const filteringOptions = [
    {
      label: 'Airline',
      key: 'airline',
      type: 'checkboxes',
      options: airlines?.map((airline) => ({ label: airline.name, key: airline.id, value: airline.name })) || null,
    },
  ]
  const { queryString, searching, sorting, filtering, pagination } = useTableFilters({
    filteringOptions,
    enableSearch: true,
  })
  const { data: validators, error, isLoading } = useQuery([`validator-airline-config`, queryString])

  const getParameters = (data) => {
    return (
      <AirlineValidatorParams
        key={`params-${data.validator_id}-${data.airline_id}`}
        name={data.validator_name}
        data={data}
      />
    )
  }

  return (
    <Table
      status={{
        pending: isLoading,
        error: error,
        errorMessage: error?.message,
      }}
      widths={['175', 'auto', '100']}
      header={{
        columns: [
          { text: 'Airline', key: 'airline' },
          { text: 'Validators', key: 'validators' },
          { text: 'Value', key: 'value' },
        ],
        searching,
        sorting,
        filtering,
      }}
      body={{
        data: validators?.data,
        row: {
          compact: true,
          truncate: true,
          render: [(data) => data.airline_name, (data) => data.validator_name, (data, index) => getParameters(data)],
        },
        empty: {
          title: 'No Airline Specific Validators found!',
          text: 'Create a new Airline to begin.',
          icon: 'check-circle',
        },
      }}
      paginate={{ ...pagination, totalRows: validators?.meta.total ?? 0 }}
    />
  )
}

export default AirlineSpecificValidatorsTable
